// components/FormBuilder/ComponentTypes/Text/index.tsx

import React from 'react';
import { Card, Input, Space, Button } from 'antd';
import { DeleteOutlined, UpOutlined, DownOutlined, DragOutlined } from '@ant-design/icons';
import { SortableHandle } from 'react-sortable-hoc';

const { TextArea } = Input;

const DragHandle = SortableHandle(() => <DragOutlined style={{ cursor: 'move' }} size={18} />);

export const TextHeading = ({ component, onChange, onDelete }) => {
    const [collapsed, setCollapsed] = React.useState(false);
    return (
        <Card
            size="small"
            draggable
            title={
                <Space direction="horizontal" align="center">
                    <DragHandle />
                    Text Heading
                </Space>
            }
            extra={
                <Space direction="horizontal">
                    <Button icon={<DeleteOutlined />} onClick={() => onDelete(component.id)} type="text" danger />
                </Space>
            }
        >
            {!collapsed && (
                <Input
                    style={{
                        paddingTop: 0,
                        paddingBottom: 0,
                    }}
                    showCount
                    maxLength={80}
                    value={component.text}
                    onChange={(e) => onChange({ ...component, text: e.target.value })}
                    placeholder="Enter text"
                />
            )}
        </Card>
    );
};

export const TextSubheading = ({ component, onChange, onDelete }) => {
    return (
        <Card
            size="small"
            draggable
            title={
                <Space direction="horizontal" align="center">
                    <DragHandle />
                    Small Heading
                </Space>
            }
            extra={<Button icon={<DeleteOutlined />} onClick={() => onDelete(component.id)} type="text" danger />}
        >
            <Input
                style={{
                    paddingTop: 0,
                    paddingBottom: 0,
                }}
                showCount
                size="small"
                maxLength={80}
                value={component.text}
                onChange={(e) => onChange({ ...component, text: e.target.value })}
                placeholder="Enter text"
            />
        </Card>
    );
};

export const TextBody = ({ component, onChange, onDelete }) => {
    return (
        <Card
            size="small"
            // title="Body"
            draggable
            title={
                <Space direction="horizontal" align="center">
                    <DragHandle />
                    Body
                </Space>
            }
            extra={<Button icon={<DeleteOutlined />} onClick={() => onDelete(component.id)} type="text" danger />}
        >
            <Space direction="vertical" style={{ width: '100%' }}>
                <TextArea
                    showCount
                    size="small"
                    maxLength={4096}
                    value={component.text}
                    onChange={(e) => onChange({ ...component, text: e.target.value })}
                    placeholder="Enter text"
                    autoSize={{ minRows: 3, maxRows: 6 }}
                />
            </Space>
        </Card>
    );
};

export const TextCaption = ({ component, onChange, onDelete }) => {
    return (
        <Card
            size="small"
            draggable
            extra={<Button icon={<DeleteOutlined />} onClick={
                () => onDelete(component.id)
            } type="text" danger />}
            title={
                <Space direction="horizontal" align="center">
                    <DragHandle />
                    Caption
                </Space>
            }
        >
            <Space direction="vertical" style={{ width: '100%' }}>
                <TextArea
                    showCount
                    maxLength={4096}
                    size="small"
                    value={component.text}
                    onChange={(e) => onChange({ ...component, text: e.target.value })}
                    placeholder="Enter text"
                    autoSize={{ minRows: 3, maxRows: 6 }}
                />
            </Space>
        </Card>
    );
};
